module.exports = __webpack_public_path__ + "media/home/employee-samples-45ea7fa6.jpg";